// The auth API the screens use: the app's instance, or a contract-validated mock in tests.
import { createContext, useContext } from "react";

import { appAuthApi } from "@/session/SessionProvider";

import type { AuthApi } from "./authApi";

export const AuthApiContext = createContext<AuthApi>(appAuthApi);

export const useAuthApi = () => useContext(AuthApiContext);
